(() => {
  if (window.edenContactGuardInitialized) return;
  window.edenContactGuardInitialized = true;
  function init(scope = document) {
    scope.querySelectorAll('form[data-eden-contact-guard="true"]').forEach(form => {
      if (form.dataset.guardReady) return;
      const message = form.querySelector('[data-eden-contact-message]');
      const trap = form.querySelector('[data-eden-contact-trap]');
      const feedback = form.querySelector('[data-eden-contact-feedback]');
      if (!message || !trap || !feedback) return;
      form.dataset.guardReady = 'true';
      const started = performance.now();
      const minimum = Number(message.minLength) || 20;
      const readableLength = () => [...message.value.replace(/[\u200B-\u200D\uFEFF]/g, '').replace(/\s+/gu, ' ').trim()].length;
      const checkMessage = () => {
        const error = readableLength() < minimum ? form.dataset.shortError : '';
        message.setCustomValidity(error);
        message.setAttribute('aria-invalid', error ? 'true' : 'false');
        return error;
      };
      message.addEventListener('input', () => {
        message.setCustomValidity('');
        message.removeAttribute('aria-invalid');
        feedback.textContent = '';
      });
      message.addEventListener('blur', () => {
        if (message.value) feedback.textContent = checkMessage();
      });
      message.addEventListener('invalid', () => {
        if (message.validity.tooShort || message.validity.customError) feedback.textContent = form.dataset.shortError;
      });
      form.addEventListener('submit', event => {
        let error = '';
        if (trap.value.trim()) error = form.dataset.blockedError;
        else error = checkMessage();
        if (!error && performance.now() - started < 3000) error = form.dataset.waitError;
        if (!error) { feedback.textContent = ''; return; }
        event.preventDefault();
        event.stopImmediatePropagation();
        feedback.textContent = error;
        if (error === form.dataset.shortError) {
          message.focus();
          message.reportValidity();
        }
      }, true);
    });
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState !== 'loading') init();
})();
